import { useEffect, useState } from 'react';
import { container } from 'tsyringe';
import { gameId, IGamesHistoryService } from '../model/interfaces';
import Empty from '@ui-kit/components/empty';
import { ReactComponent as NoFeeStatistics } from '@base/assets/images/no_fee_statistics.svg';
import { t } from '@base/utils/helpers';
import { useAsyncData } from '@utils/hooks';
import DataTable from '@base/ui/components/dataTable';
import styles from '../styles/gameHistory.module.scss';
import enEN from 'rc-picker/lib/locale/en_US';
import Picker from 'rc-picker/lib/Picker';
import generateConfig from 'rc-picker/lib/generate/moment';
import MainButton from '@ui-kit/components/mainButton';
import { objectKeys } from '@utils/functions';
import { gameHistoryColumnsForAdmins, gameHistoryColumnsForPlayers } from './gameHistoryColumns';
import PlayersOnlineRepository from '@base/features/player/model/playersOnlineRepository';
import moment, { Moment } from 'moment';
import useSession from '@base/utils/hooks/useSession';

export enum HistoryRoutes {
  BACKGAMMON = 'backgammon',
  СRIBBAGE = 'сribbage',
  GIN_RUMMY = 'gin rummy',
  RED_MAHJONG = 'red mahjong',
  DOMINOS = 'dominos',
}

export default function GameHistory() {
  const gamesHistoryService: IGamesHistoryService = container.resolve('gamesHistoryService');
  const getHistory = async () => gamesHistoryService.getGamesHistory(gameId[active], date);

  const [active, setActive] = useState<HistoryRoutes>(HistoryRoutes.BACKGAMMON);
  const [date, setRange] = useState<Moment | null>();
  const [loadingNewDate, setLoadingNewDate] = useState(false);
  const currentUser = useSession();

  const { data, loading, setData } = useAsyncData(getHistory ,active);
  const playersOnlineRepository: PlayersOnlineRepository = container.resolve('playersOnlineRepository');

  const matReader = playersOnlineRepository.me?.isTD() || playersOnlineRepository.me?.isAdmin();

  useEffect(() => {
    setLoadingNewDate(true);
    getHistory().then((res) => {
      setLoadingNewDate(false);
      setData(res);
    });
  }, [date])

  return (
    <div className={styles.filteredTable}>
      <header className={styles.header}>
        <ul className={styles.menuItems}>
          {objectKeys(HistoryRoutes).map((key) => (
            <li
              key={key}
              className={HistoryRoutes[key] === active ? styles.active : undefined}
              onClick={() => setActive(HistoryRoutes[key])}
            >
              {HistoryRoutes[key]}
            </li>
          ))}
        </ul>
        <div className={styles.rangePicker}>
          <span>{t('Games played during')}</span>
          <Picker
            generateConfig={generateConfig}
            locale={enEN}
            disabledDate={(date) => date.isAfter(moment.now())}
            allowClear
            onChange={setRange}
          />
        </div>
      </header>
      <DataTable
        loading={loadingNewDate || loading}
        data={data}
        columns={
          matReader && currentUser
            ? gameHistoryColumnsForAdmins(currentUser, gameId[active])
            : gameHistoryColumnsForPlayers
        }
        empty={<NoGames />}
        style={{ fontSize: '0.9rem' }}
      />
    </div>
  );
}

const NoGames = () => (
  <Empty icon={<NoFeeStatistics height="124px" width="144px" />} style={{ margin: '100px' }}>
    {t('no_games_history')}
  </Empty>
);
